import { LocationPage } from "@/components/locations/LocationPage";
import { getLocationBySlug } from "@/data/locations";

const BookkeepingServicesDurban = () => {
  const location = getLocationBySlug("durban")!;
  return <LocationPage location={location} />;
};

export default BookkeepingServicesDurban;
